<template>
  <div :style="style"><slot/></div>
</template>

<script>
import colors from '@/services/colors'

export default {
  name: 'StrongText',
  props: {
    color: {
      required: false,
      default: colors.blue
    }
  },
  computed: {
    style() {
      return {
        color: this.color
      }
    }
  }
}
</script>

<style lang="scss" scoped>
div {
  font-size: 25px;
  font-weight: 600;
}
</style>
